export default __webpack_public_path__ + "img/favicons/favicon-32x32.png";